export class ProductMedia extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot', 'next', 'previous'])
  }

  initialiseCarousel () {
    const initialSlide = parseInt(this.dataset.initialSlide, 10)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        initial: initialSlide,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els.dot.elements),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
